import { Divider as AntDivider, Space } from 'antd';
import styled from 'styled-components';

import { Text, Title as TitleComponent } from '@atom/typography/typography';
import { ColorEnum } from '@enum/style/color.enum';

export const Title = styled(TitleComponent).attrs((props) => ({
  color: props.theme.Title.colorSignUpTitle,
}))``;

export const FormWrapper = styled.div`
  flex: 1;
  width: 100%;
  max-width: 318px;
`;

export const RegistrationFormWrapper = styled.div`
  margin-top: -2px;
`;

export const Divider = styled(AntDivider)`
  border-block-start-color: ${(props) => props.theme.Divider.mainColor};
`;

export const ButtonSpace = styled(Space)`
  display: flex;
  margin-top: 8px;
`;

export const ButtonTitle = styled(Text).attrs((props) => ({
  color: props.theme.Title.colorSignUpSocialTitle,
}))``;

export const HaveUserParagraph = styled(Title).attrs(() => ({
  color: ColorEnum.Black100,
  level: 6,
  weight: 400,
}))`
  padding-top: 2px;
  margin-bottom: 8px !important;
`;
